import { SmartLink } from "@selector/shared/components";
import type { FC } from "react";
import type { GridCard } from "widgets";
import { Card, CardRowSimple, Tag } from "widgets";

import { getGeneTypeColor } from "@/app-utils/color.js";
import type { Contig } from "@/graphql.js";
import { getUserDisplayName } from "@/modules/users/utils/user.js";
import { uploaderFieldLabel } from "@/settings/settings.js";

import style from "../../core/cards/styles/Card.module.scss";

export interface IContigCardProps extends GridCard {
  contig: Contig;
  blastContext?: boolean;
}

const ContigCard: FC<IContigCardProps> = (props: IContigCardProps) => {
  const { contig, blastContext } = props;

  if (!contig) {
    return null;
  }

  return (
    <Card title={"Contig Info"}>
      <CardRowSimple label={"Type"}>
        <div className={style.tags_list}>
          <Tag intentColor={getGeneTypeColor(contig.sequenceType)}>{contig.sequenceType}</Tag>
        </div>
      </CardRowSimple>
      <CardRowSimple
        label={"Sequence ID (accession.version)"}
        value={
          blastContext ? <SmartLink to={`/contig/${contig.id}`}>{contig.sequenceId}</SmartLink> : contig.sequenceId
        }
      />
      <CardRowSimple label={"Name"} value={contig.name} />
      <CardRowSimple label={"Description"} value={contig.description} />
      {/* We need to report the ges.species to support metagenomes, SEL6-2581 */}
      <CardRowSimple label={"Species"} value={<em>{contig.species.name}</em>} />
      <CardRowSimple label={uploaderFieldLabel} value={getUserDisplayName(contig.creator)} />
    </Card>
  );
};

export { ContigCard };
